import { render, staticRenderFns } from "./deleteReserveCatalog.vue?vue&type=template&id=0ccc74cf&scoped=true"
import script from "./deleteReserveCatalog.vue?vue&type=script&lang=js"
export * from "./deleteReserveCatalog.vue?vue&type=script&lang=js"
import style0 from "./deleteReserveCatalog.vue?vue&type=style&index=0&id=0ccc74cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccc74cf",
  null
  
)

export default component.exports